export default __webpack_public_path__ + "static/logo-792617df9317d2e97cbfcd786c7b3323.svg";